import throttle from "lodash/throttle";

export default function scrollStateChecker(element, className) {
  function checkScrollState() {
    if (element.scrollTop > 0) {
      element.classList.add(className);
    } else {
      element.classList.remove(className);
    }
  }

  const checkScroll = throttle(checkScrollState, 150);

  element.addEventListener("scroll", checkScroll, true);
  checkScrollState();
  return function () {
    element.removeEventListener("scroll", checkScroll);
  };
}
